module.exports = __webpack_public_path__ + "img/19_windAndRain_lwl.297dbbf4.png";